import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { KeyboardShortcutsModalCompass } from "./KeyboardShortcutsModalCompass";

const KeyboardShortcutsModal = ModalManager.create(() => {
  const modal = useModal();

  return (
    <KeyboardShortcutsModalCompass
      open={modal.visible}
      onOpenChange={open => {
        if (!open) {
          void modal.hide();
        }
      }}
    />
  );
});

export const useKeyboardShortcutsModal = () => useModal(KeyboardShortcutsModal);
